<template>
  <b-card
    no-body
    class="p-1"
  >
    <b-tabs lazy>
      <template #tabs-start>
        <li class="nav-item d-flex align-items-center mr-2">
          <h4 class="mb-0">
            Orders
          </h4>
        </li>
      </template>

      <b-tab
        title="Retailers"
        active
      >
        <retailer-orders-filters @filtersUpdated="retailerFiltersChangeHandler" />
        <retailer-orders-list :filters="retailerFilters" />
      </b-tab>

      <b-tab title="Salesman">
        <salesman-orders-filters @filtersUpdated="salesmanFiltersChangeHandler" />
        <salesman-orders-list :filters="salesmanFilters" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BCard,
  BTabs,
  BTab,
} from 'bootstrap-vue'
import SalesmanOrdersList from '@/components/Sales/Orders/OrdersList.vue'
import SalesmanOrdersFilters from '@/components/Sales/Orders/OrdersFilters.vue'
import RetailerOrdersList from '@/components/Retailers/Orders/OrdersList.vue'
import RetailerOrdersFilters from '@/components/Retailers/Orders/OrdersFilters.vue'
import dateMixin from '@/mixins/dateMixin'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    SalesmanOrdersList,
    SalesmanOrdersFilters,
    RetailerOrdersList,
    RetailerOrdersFilters,
  },
  mixins: [dateMixin],
  data() {
    return {
      salesmanFilters: {
        created_date_from: this.formatedDate(new Date(), 'YYYY-MM-DD'),
        created_date_to: this.formatedDate(new Date(), 'YYYY-MM-DD'),
      },
      retailerFilters: {
        created_date_from: this.formatedDate(new Date(), 'YYYY-MM-DD'),
        created_date_to: this.formatedDate(new Date(), 'YYYY-MM-DD'),
      },
    }
  },
  methods: {
    salesmanFiltersChangeHandler(filterData) {
      this.salesmanFilters = filterData
    },
    retailerFiltersChangeHandler(filterData) {
      this.retailerFilters = filterData
    },
  },
}
</script>
